import { FC, memo } from 'react'
import { Flex, Stack, StackProps, Text } from '@chakra-ui/react'

type Props = {
  stackProps?: StackProps
  content: JSX.Element
  title: string
  description?: string
}

const FilterTemplate: FC<Props> = ({
  stackProps,
  content,
  title,
  description = 'Aparecerá os campos que você pesquisou ao fechar este formulário.',
}) => {
  return (
    <Stack p={4} {...stackProps}>
      <Flex width="100%" direction="column" mb={2}>
        <Flex justify="space-between" gap={2}>
          <Flex direction="column" textAlign="left" gap={1}>
            <Flex className="filter-groups" align="center" gap={2}>
              <Text fontSize="md" className="accessible">
                {title}
              </Text>
            </Flex>
            {description && <Text variant="secondary">{description}</Text>}
          </Flex>
        </Flex>
      </Flex>

      {content}
    </Stack>
  )
}

export default memo(FilterTemplate)
